import { useCallback } from 'react';

import {
  EscuelaTO,
  PosicionParticipanteMiEscuelaTO,
  ResponseTdeRankingData,
  UsuarioTO,
} from '@/types/tde';
import { cn } from '@/utils';

const ItemTdeTable = ({
  item,
  isFirst,
  schooldata,
  activeTab,
}: {
  item: EscuelaTO | UsuarioTO | PosicionParticipanteMiEscuelaTO;
  isFirst: boolean;
  schooldata: ResponseTdeRankingData;
  index: number;
  activeTab: string;
}) => {
  // Type guards
  const isEscuelaTO = (item: any): item is EscuelaTO => {
    return 'nombre' in item;
  };

  const isUsuarioTO = (item: any): item is UsuarioTO => {
    return 'nombreCompleto' in item;
  };

  const isPosicionParticipanteMiEscuelaTO = (
    item: any
  ): item is PosicionParticipanteMiEscuelaTO => {
    return 'nombreParticipante' in item;
  };

  const positionValue = useCallback(() => {
    if (item) {
      if (isEscuelaTO(item)) {
        return `${item.puesto}`;
      } else if (isUsuarioTO(item)) {
        return `${item.puesto}`;
      } else if (isPosicionParticipanteMiEscuelaTO(item)) {
        return `${item.puesto}`;
      }
    }
  }, [item]);

  const nameValue = useCallback(() => {
    if (item) {
      if (isEscuelaTO(item)) {
        return `${item.nombre}`;
      } else if (isUsuarioTO(item)) {
        return `${item.nombreCompleto}`;
      } else if (isPosicionParticipanteMiEscuelaTO(item)) {
        return `${item.nombreParticipante}`;
      }
    }
  }, [item]);

  const scorePointsValue = useCallback(() => {
    if (item) {
      if (isEscuelaTO(item)) {
        return `${item.puntos}`;
      } else if (isUsuarioTO(item)) {
        return `${item.puntos}`;
      } else if (isPosicionParticipanteMiEscuelaTO(item)) {
        return `${item.cantPuntos}`;
      }
    }
  }, [item]);

  const provinceValue = useCallback(() => {
    if (item) {
      if (isEscuelaTO(item)) {
        return `${item.provincia} - ${item.localidad}`;
      } else if (isUsuarioTO(item)) {
        return `${item.provincia} - ${item.localidad}`;
      } else if (isPosicionParticipanteMiEscuelaTO(item)) {
        return `${schooldata.escuelaUsuario?.provinciaEscuela ?? ''} - ${
          schooldata.escuelaUsuario?.localidadEscuela ?? ''
        }`;
      }
    }
  }, [item, schooldata]);

  const schoolValue = useCallback(() => {
    if (item) {
      if (isUsuarioTO(item)) {
        return `${item.escuela}`;
      }
    }
  }, [item]);

  return (
    <>
      {item && (
        <div className="flex justify-stretch bg-white border-b-gdt-gray-6 border-b-[1px] px-7 lg:py-6 text-sm font-semibold text-gdt-gray-3 py-4">
          <div className="w-12 lg:w-[68px]">
            <div
              className={cn(
                'rounded-full bg-gdt-blue text-white w-9 h-9 lg:w-10 lg:h-10 font-bold text-lg flex justify-center items-center',
                {
                  'text-gdt-blue bg-gdt-blue-light2': !isFirst,
                }
              )}
            >
              <span>{positionValue()}</span>
            </div>
          </div>
          <div className="flex-1 space-y-1">
            <p className="font-bold text-gdt-gray capitalize">{nameValue()}</p>
            {schooldata.escuelaUsuario && activeTab === 'mySchoolsData' && (
              <p className="uppercase font-bold text-3xs text-gdt-gray-2">
                {schooldata.escuelaUsuario.nombreEscuela}
              </p>
            )}
            {activeTab === 'studentsData' && (
              <p className="uppercase font-bold text-xs text-gdt-gray-2">
                {schoolValue()}
              </p>
            )}
            <p className="uppercase font-bold text-xs text-gdt-gray-4">
              {provinceValue()}
            </p>
          </div>
          <p className="w-[62px] text-[18px] text-gray-950 text-right lg:w-[113px] lg:text-center">
            {scorePointsValue()}
          </p>
        </div>
      )}
    </>
  );
};

export default ItemTdeTable;
